import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { Observable } from 'rxjs';
import { ServiceDeviation } from '@wilson/service-deviation/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ServiceDeviationGateway {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  public createServiceDeviation(
    serviceDeviation: ServiceDeviation,
  ): Observable<ServiceDeviation> {
    return this.httpClient.post<ServiceDeviation>(
      `${this.config.host}/service-deviations`,
      serviceDeviation,
    );
  }
}
